import API from './base';

class MeetingsAPI extends API {
  list(schoolId, dateMin, dateMax) {
    return this.get(`/api/web/v1/schools/${schoolId}/slots?begins_at=${dateMin}&ends_at=${dateMax}`);
  }

  book(payload) {
    return this.post('/api/web/v1/meetings', payload);
  }

  listMeetingSubjects(schoolId) {
    return this.get(`/api/web/v1/schools/${schoolId}/meeting_categories`);
  }

  count(schoolId) {
    return this.get(`/api/web/v1/schools/${schoolId}/meetings_count`);
  }

  getMeetingInfo(meetingId) {
    return this.get(`/api/web/v1/meetings/${meetingId}`);
  }

  updateMeeting(meetingId, payload) {
    return this.put(`/api/web/v1//meetings/${meetingId}`, payload);
  }

  cancelMeeting(meetingId) {
    return this.delete(`/api/web/v1//meetings/${meetingId}`);
  }
}

export default new MeetingsAPI();
